<template>
	<div>
		<!-- 底部 -->
		<div class="service">
<!--			<img src="../../assets/img/logo.png" alt="">-->
      <div style="color: #fff; font-size: 16px; text-align: center">
        重庆云锦荣科技有限公司<br/>
        <br/>
        Chongqing Yunjinrong Technology Co., Ltd
      </div>
			<div class="service-product">
				<div>服务与产品</div>
				<div>技术咨询</div>
				<div>软件服务</div>
			</div>
			<div class="service-address">
				<div>联系我们</div>
				<div>联系地址：重庆市 渝北区 园博园 两江盛景 </div>
				<div>联系电话：18716389434</div>
			</div>
		</div>
		<!-- 备案号 -->
		<footer>
			<img src="../../assets/icon/record.png" alt="" class="record">
			<div>云锦荣官网&nbsp;&nbsp;&nbsp;<span @click="record">渝ICP备2023013621号-2©</span>&nbsp;&nbsp;&nbsp;2018-{{year}} 云锦荣 - 给与您的帮助，是我们最大的荣幸</div>
		</footer>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				year:''
			}
		},
		created(){
			this.year=new Date().getFullYear()
		},
		methods:{
			record(){
				window.open('https://beian.miit.gov.cn/#/Integrated/index','_black')
			},
		}
	})
</script>

<style lang="scss" scoped>
	.service{
		background:#000;
		padding:3rem 2rem;
		box-sizing: border-box;
		display:flex;
		justify-content: space-between;
		>img{
			width:6.4rem;
			height:2rem;
		}
		.service-product{
			>div{
				font-size: 0.7rem;
				color: var(--main-color);
				line-height: 1.1rem;
				margin-bottom:.4rem;
				&:nth-child(1){
					font-weight: 600;
					margin-bottom:.8rem;
					line-height: 1.2rem;
					color:#fff;
				}
				&:last-child{
					margin-bottom:0;
				}
			}
		}
		.service-address{
			>div{
				font-size: 0.7rem;
				color: var(--main-color);
				line-height: 1.1rem;
				margin-bottom:.8rem;
				&:nth-child(1){
					font-weight: 600;
					line-height: 1.2rem;
					color:#fff;
				}
			}
		}
	}
	footer{
		display:flex;
		justify-content: center;
		padding:2.45rem 0;
		font-size: 0.7rem;
		line-height: 1.1rem;
		color: var(--main-color);
		align-items: center;
		position: relative;
		>img{
			width:.7rem;
			height:.7rem;
			margin-right:.3rem;
		}
		>div{
			>span{
				cursor: pointer;
				&:hover{
					color:#be8734
				}
			}
		}

	}
</style>
